exports.vanStatuses = require('./schema').properties.status.enum
